import React, { useState } from 'react';
import LoginForm from './components/LoginForm';
import MachineSelector from './components/MachineSelector';
import ConcentrationPlot from './components/ConcentrationPlot';
import Parse from 'parse';
import './App.css';

Parse.initialize('YOUR_APP_ID');
Parse.serverURL = 'https://parseapi.back4app.com/';

function App() {
  const [user, setUser] = useState(null);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const [commandId, setCommandId] = useState(null);
  const [buttonsDisabled, setButtonsDisabled] = useState(false);

  const handleLogin = (user) => {
    setUser(user);
  };

  const handleLogout = async () => {
    await Parse.User.logOut();
    setUser(null);
    setSelectedMachine(null);
  };

  const handleMachineSelect = (machine) => {
    setSelectedMachine(machine);
  };

  const sendCommand = async (cmd) => {
    setButtonsDisabled(true);
    setStatus(`Sending "${cmd}" command...`);
    setLoading(true);

    const DeviceCommand = Parse.Object.extend('DeviceCommand');
    const command = new DeviceCommand();
    command.set('device', selectedMachine);
    command.set('command', cmd);
    command.set('executed', false);

    try {
      const saved = await command.save();
      setCommandId(saved.id);
      setStatus(`✅ Command "${cmd}" sent to Microdeep unit.`);

      setTimeout(() => checkCommandExecuted(saved.id, cmd), 30000);
      setTimeout(() => setButtonsDisabled(false), 30000);
    } catch (err) {
      console.error('Error sending command:', err);
      setStatus('❌ Failed to send command.');
      setLoading(false);
      setButtonsDisabled(false);
    }
  };

  const checkCommandExecuted = async (id, cmd) => {
    const DeviceCommand = Parse.Object.extend('DeviceCommand');
    const query = new Parse.Query(DeviceCommand);

    try {
      const cmdObj = await query.get(id);
      if (cmdObj.get('executed')) {
        setStatus(`✅ Command "${cmd}" received by Microdeep unit.`);
      } else {
        setStatus(`⚠️ Command "${cmd}" not yet acknowledged.`);
      }
    } catch (err) {
      console.error('Polling error:', err);
      setStatus('❌ Could not verify command status.');
    }

    setLoading(false);
  };

  return (
    <div style={{ padding: 20 }}>
      <div className="top-bar">
        <img src="/microdeep-logo.png" alt="Microdeep logo" className="logo" />
      </div>
      <h1 className="dashboard-title">Dashboard</h1>

      {user ? (
        <>
          <div className="header-card">
            <p>Welcome, {user.getUsername()}!</p>
            <button onClick={handleLogout} className="logout-button">Logout</button>
            <p>Select your Microdeep unit:</p>
            <MachineSelector user={user} onSelect={handleMachineSelect} />
            {selectedMachine && <p>You selected: {selectedMachine.get('name')}</p>}
          </div>

          {selectedMachine && (
            <>
              <div className="glass-panel" style={{ marginBottom: 20, textAlign: 'center' }}>
                <h4>Remote Control</h4>
                <div style={{ marginBottom: 10 }}>
                  <button className="orange-button" onClick={() => sendCommand('start')} disabled={loading || buttonsDisabled}>
                    ▶ Start Sequence
                  </button>
                  <button className="orange-button" onClick={() => sendCommand('stop')} disabled={loading || buttonsDisabled}>
                    ■ Stop Sequence
                  </button>
                  {loading && (
                    <span style={{ marginLeft: 10, display: 'inline-block' }}>
                      <span className="spinner" style={{ display: 'inline-block', verticalAlign: 'middle' }} />
                    </span>
                  )}
                </div>
                <p>{status}</p>
              </div>
              <ConcentrationPlot machine={selectedMachine} />
            </>
          )}
        </>
      ) : (
        <div className="header-card">
          <LoginForm onLogin={handleLogin} />
        </div>
      )}
    </div>
  );
}

export default App;